import { useReservationWizardStore } from '@/features/reservation/stores/useReservationWizardStore'

const PARTNER_CHECKOUT_LATER_PREFIX = 'partner:checkout:later:'

/**
 * Clear ephemeral order drafts after logout / idle session expiry.
 * Does not touch cookie-consent or theme preferences.
 */
export function clearPortalOrderDrafts(): void {
  useReservationWizardStore.getState().reset()
  try {
    const keys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key !== null && key.startsWith(PARTNER_CHECKOUT_LATER_PREFIX)) {
        keys.push(key)
      }
    }
    for (const key of keys) {
      localStorage.removeItem(key)
    }
  } catch {
    // ignore quota / private mode
  }
}
